import { render } from "./LtrDefaultsSettings.vue?vue&type=template&id=63e0d360&scoped=true"
import script from "./LtrDefaultsSettings.vue?vue&type=script&lang=js"
export * from "./LtrDefaultsSettings.vue?vue&type=script&lang=js"

import "./LtrDefaultsSettings.vue?vue&type=style&index=0&id=63e0d360&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e0d360"]])

export default __exports__